import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ModalInfo } from 'shared/components';
import { convertKeywords } from 'shared/helpers';

import './NotificationDetails.scss';

const NotificationDetails = (props) => {
  const { t } = useTranslation();

  return (
    props.notification && (
      <ModalInfo
        modalIsOpen={props.modalIsOpen}
        closeModal={props.closeNotification}
        headerTitle={t('notifications.modalTitle')}
        onSubmit={props.closeNotification}
        saveLabel={t('common.labels.close')}
        className="notification-details">
        <h4>{props.notification.title}</h4>

        <div className="date">
          {props.notification.days
            ? t('notifications.daysLabel', { count: props.notification.days })
            : t('common.labels.today')}
        </div>

        <div dangerouslySetInnerHTML={{ __html: convertKeywords(props.notification.body) }} />
      </ModalInfo>
    )
  );
};

NotificationDetails.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  closeNotification: PropTypes.func.isRequired,
};

export default NotificationDetails;
